import { TransactionQueryKeys } from '@/modules/transaction/keys'
import {
	GetTrueWalletLogsParams,
	PaginatedTrueWalletTransactionLogsResponse,
} from '@/modules/transaction/types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import BankTransactionService from '../../services'

export const queryTrueWalletLogsOptions = (
	payload: GetTrueWalletLogsParams,
	options?: UnusedSkipTokenOptions<PaginatedTrueWalletTransactionLogsResponse>,
) => ({
	queryKey: [TransactionQueryKeys.TRUE_WALLET_LOGS, payload],
	queryFn: () => BankTransactionService.getTrueWalletTransactionLogs(payload),
	...options,
})
